import { render, staticRenderFns } from "./appAstrbot.vue?vue&type=template&id=29175f80&scoped=true"
import script from "./appAstrbot.vue?vue&type=script&lang=js"
export * from "./appAstrbot.vue?vue&type=script&lang=js"
import style0 from "./appAstrbot.vue?vue&type=style&index=0&id=29175f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29175f80",
  null
  
)

export default component.exports